/// <reference types="@angular/localize" />
/// <reference types="mixpanel" />

import { bootstrapApplication } from "@angular/platform-browser";
import { appConfig } from "./app.config";
import { AppComponent } from "./app/app.component";



bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));